import { render, staticRenderFns } from "./MainDashboard.vue?vue&type=template&id=71cdf7ae&scoped=true&"
import script from "./MainDashboard.vue?vue&type=script&lang=js&"
export * from "./MainDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71cdf7ae",
  null
  
)

export default component.exports